<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">
      <div class="row m-3 justify-content-center">

        <div class="col-lg-10">
          <div class="row mb-4">
            <div class="col-md-8">
              <p class="h4 d-inline-block me-3">
                <b>Escolha o paciente</b>
              </p>
              <button type="button" class="btn btn-outline-primary btn-sm d-inline-block"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
            <div class="col-md-4 text-sm-end">
              <div class="d-grid gap-2">
                <button class="btn btn-outline-primary" @click="onClickBtnStore()">
                  Novo paciente
                </button>
              </div>
            </div>
          </div>

          <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate"
               @click="selectPatient(patient)" title="Agendar para esse paciente"
               style="cursor: pointer;" v-for="patient in patients">
            <div class="ribbon ribbon-right ribbon-warning overflow-hidden" v-if="patient.main">
              <span class="text-center d-block shadow small h6">Você</span>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="m-3">
                      <span class="text-primary">
                        <b>{{ patient.patient_name }}</b>
                      </span>
                  <br><span class="text-primary">
                        {{ patient.patient_full_age }}
                      </span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mx-3 mb-3 text-center">
                  <div class="d-grid gap-2 d-md-block">
                    <button type="button" class="btn btn-primary"
                            @click="selectPatient(patient)" title="Agendar para esse paciente">
                      Agendar <i class="ms-1 fas fa-1x fa-arrow-circle-right"></i>
                    </button>
                    <button type="button" class="btn btn-outline-primary ms-xl-2"
                            @click.stop="onClickBtnEdit(patient)">
                      Editar <i class="fa fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="modal fade" id="ExamModalNewPatient" tabindex="-1" aria-labelledby="ModalAddress" aria-hidden="true">
      <div class="modal-dialog">
        <form method="post" @submit.prevent="formPatient.id_patient ? updatePatient() : storePatient()"
              ref="formPatient">
          <div class="modal-content rounded shadow border-0">
            <div class="modal-header border-bottom">
              <h5 class="modal-title">{{ formPatient.id_patient ? 'Editar' : 'Novo' }} paciente</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">

                  <div class="alert alert-success" role="alert" v-if="msgPatientSuccess">
                    {{ msgPatientSuccess }}
                  </div>

                  <div class="alert alert-danger" role="alert" v-if="msgPatientError">
                    {{ msgPatientError }}
                  </div>

                  <div class="mb-3">
                    <label class="form-label" for="patient_name">Nome <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                           class="feather feather-user fea icon-sm icons">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                      <input name="patient_name" id="patient_name" type="text" v-model="formPatient.patient_name"
                             :class="errors.patient_name ? 'is-invalid' : ''" required
                             class="form-control ps-5" placeholder="Nome :">
                      <div class="invalid-feedback d-block" v-if="errors.patient_name">
                        {{ errors.patient_name.join('\n') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="patient_cpf">CPF <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                           class="feather feather-mail fea icon-sm icons">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <input name="patient_cpf" id="patient_cpf" type="tel" v-model="formPatient.patient_cpf"
                             :class="errors.patient_cpf ? 'is-invalid' : ''" v-mask="'###.###.###-##'"
                             class="form-control ps-5" placeholder="CPF :" required>
                      <div class="invalid-feedback d-block" v-if="errors.patient_cpf">
                        {{ errors.patient_cpf.join('\n') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="patient_birthdate">Data Nascimento <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                           class="feather feather-mail fea icon-sm icons">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <input name="patient_birthdate" id="patient_birthdate" type="tel"
                             v-model="formPatient.patient_birthdate" required
                             :class="errors.patient_birthdate ? 'is-invalid' : ''" v-mask="'##/##/####'"
                             class="form-control ps-5" placeholder="Data de nascimento :">
                      <div class="invalid-feedback d-block" v-if="errors.patient_birthdate">
                        {{ errors.patient_birthdate.join('\n') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="patient_gender">Sexo</label>
                    <select id="patient_gender" v-model="formPatient.patient_gender" class="form-select">
                      <option :value="null">Selecione</option>
                      <option value="Male">Masculino</option>
                      <option value="Female">Feminino</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label" for="observations">Observação</label>
                    <div class="form-icon position-relative">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                           class="feather feather-message-circle fea icon-sm icons">
                        <path
                          d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                      </svg>
                      <textarea name="observations" id="observations" rows="4"
                                :class="errors.observations ? 'is-invalid' : ''" v-model="formPatient.observations"
                                class="form-control ps-5" placeholder="Observação do paciente :"></textarea>
                      <div class="invalid-feedback d-block" v-if="errors.observations">
                        {{ errors.observations.join('\n') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="col-md-12">
                <div class="d-grid gap-2">
                  <button type="submit" :disabled="submitted" class="btn btn-outline-primary">
                    Salvar
                    <svg v-if="submitted" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner"
                         class="local-spin svg-inline--fa fa-spinner fa-w-16" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path fill="currentColor"
                            d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import http from "../../../helpers/http";
import {mask} from 'vue-the-mask';
import Modal from "../../../helpers/modal";
import date from "../../../helpers/date";

export default {
  name: 'ExamPatient',
  directives: {
    mask,
  },
  data() {
    return {
      search: '',
      submitted: false,
      formPatient: {
        patient_name: '',
        patient_cpf: '',
        patient_birthdate: '',
        patient_gender: null,
        observations: '',
      },
      errors: [],
      msgPatientSuccess: '',
      msgPatientError: '',
    }
  },
  computed: {
    patients() {
      let patients = this.$store.state.toSchedule.patients;
      if (this.search === '')
        return patients;

      return patients.filter(patient => {
        let strFilter = JSON.stringify(patient);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
    paymentMethod() {
      return this.$store.state.toSchedule.schedule.paymentMethod;
    },
  },
  mounted() {
    this.$store.dispatch('toSchedule/getPatients');
  },
  methods: {
    date: date,
    onClickBtnStore() {
      this.msgPatientSuccess = '';
      this.formPatient = {
        patient_name: '',
        patient_cpf: '',
        patient_birthdate: '',
        patient_gender: null,
        observations: '',
      };

      Modal.toggle('#ExamModalNewPatient');
    },
    onClickBtnEdit(patient) {
      this.msgPatientSuccess = '';
      this.formPatient = {
        id_patient: patient.id_patient,
        patient_name: patient.patient_name,
        patient_cpf: patient.patient_cpf,
        patient_birthdate: patient.patient_birthdate_br,
        patient_gender: patient.patient_gender ?? null,
        observations: patient.observations,
      };

      Modal.toggle('#ExamModalNewPatient');
    },
    updatePatient() {
      this.submitted = true;
      let userAuth = this.$store.state.auth.user;
      this.errors = [];
      this.msgPatientError = '';
      http.put(`/users/${userAuth.id_user}/patients/${this.formPatient.id_patient}`, this.formPatient).then((_) => {
        this.msgPatientSuccess = 'Paciente atualizado com sucesso.';
        this.$store.dispatch('toSchedule/getPatients');
        this.formPatient = {
          patient_name: '',
          patient_cpf: '',
          patient_birthdate: '',
          patient_gender: null,
          observations: '',
        };

        Modal.toggle('#ExamModalNewPatient');
      }).catch((error) => {
        let response = error.response;
        if (response?.status === 422) {
          this.errors = response.data.errors;
        } else {
          this.msgPatientError = response.data;
        }
      }).finally(() => {
        this.submitted = false;
      });
    },
    selectPatient(patient) {
      this.selectPatientAndGoToNextStep(patient);
    },
    selectPatientAndGoToNextStep(patient) {
      this.$store.commit('toSchedule/selectPatient', patient);
      this.$router.push('/exams/payment');
    },
    storePatient() {
      this.submitted = true;
      let userAuth = this.$store.state.auth.user;
      this.errors = [];
      this.msgPatientError = '';
      delete this.formPatient.id_patient;
      delete this.formPatient._method;
      http.post(`/users/${userAuth.id_user}/patients`, this.formPatient).then((_) => {
        this.msgPatientSuccess = 'Paciente cadastrado com sucesso.';
        this.$store.dispatch('toSchedule/getPatients');
        this.formPatient = {
          patient_name: '',
          patient_cpf: '',
          patient_birthdate: '',
          patient_gender: null,
          observations: '',
        };

        Modal.toggle('#ExamModalNewPatient');
      }).catch((error) => {
        let response = error.response;
        if (response?.status === 422) {
          this.errors = response.data.errors;
        } else {
          this.msgPatientError = response.data;
        }
      }).finally(() => {
        this.submitted = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
